import '@styles/webdesktop/stylesheets/sideToggle.scss';
import React from 'react';
import { Stack } from '../Stack/Stack';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { Spacing } from '@front/sharedcomponents/Variables';
import { SideToggleOption } from './SideToggleOption';
import { useLocalize } from '../../hooks/useLocalize';
export const SideToggle = ({ side, isReverseOrder, onSideChange, disabled = false }) => {
    const [sellText, buyText] = useLocalize('general.trading.Sell', 'general.trading.Buy');
    const uid = React.useId();
    const groupId = `side-toggle-${uid}`;
    const handleSideChange = (newSide) => {
        if (side !== newSide) {
            onSideChange(newSide);
        }
    };
    return (React.createElement(Stack, { className: `side-toggle ${side === OperationType.Buy ? 'side-buy-active' : 'side-sell-active'}`, direction: isReverseOrder ? 'row-reverse' : 'row', role: "radiogroup", spacing: Spacing.None },
        React.createElement(SideToggleOption, { groupId: groupId, value: OperationType.Buy, checked: side === OperationType.Buy, text: buyText, onChange: handleSideChange, disabled: disabled }),
        React.createElement(SideToggleOption, { groupId: groupId, value: OperationType.Sell, checked: side === OperationType.Sell, text: sellText, onChange: handleSideChange, disabled: disabled })));
};
